import { styled } from 'styles';

export const StyledTabsContainerShadow = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  filter: 'drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.15))',
});

export const StyledTabsListShadow = styled('div', {
  display: 'flex',
  variants: {
    hasShadow: {
      false: {
        borderBottom: '1px solid grey',
      },
    },
  },
});

export const StyledTabPanelShadow = styled('div', {
  padding: 16,
  display: 'flex',
  backgroundColor: 'white',
  borderBottomLeftRadius: 8,
  borderBottomRightRadius: 8,
});

export const StyledTabShadow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  padding: 8,
  backgroundColor: 'white',
  borderTopLeftRadius: 12,
  borderTopRightRadius: 12,
  justifyContent: 'center',
  minWidth: 200,
  '@lg': {
    '&:hover': {
      opacity: 0.4,
    },
  },
  '@md': {
    minWidth: 250,
  },
  variants: {
    isDisabled: {
      true: {
        opacity: 0.5,
        cursor: 'not-allowed',
      },
    },
    isSelected: {
      true: {
        color: '$info',
      },
      false: {
        backgroundColor: '$neutral1',
        color: '$neutral3',
      },
    },
  },
});
